import React from "react";

import styles from "./ChatImgModal.module.scss";

type Props = {
  img: string;
  handleModalClose: (value: boolean) => void;
};

const ChatImgModal: React.FC<Props> = ({ img, handleModalClose }) => {
  return (
    <div
      className={styles["f-chatImgModal"]}
      onClick={() => handleModalClose(false)}
    >
      <img src={img} />
    </div>
  );
};

export default ChatImgModal;
